import { setTerm } from './helpers';

export const setIsSeparatedInputType = setTerm('is_separated_input_type');
